import React from 'react';
import NotificationContactSupport from './notification-contact-support';
import NotificationDownloadFile from './notification-download-file';
import {
    LogNotificationDto,
    notificationMessages,
    NotificationResponseStatus, NotificationType
} from 'src/dtos/notification.dto';

interface LogNotificationProps {
    notification: LogNotificationDto;
    isFailure: boolean;
}

const LogNotification: React.FC<LogNotificationProps> = ({ notification, isFailure }) => {
const { message } = notificationMessages[NotificationType.LOG_EXPORT][notification.status];
    return <>
        <div className="details">
            <span>{message}</span>
            {isFailure && <NotificationContactSupport/>}
        </div>
        {notification.status === NotificationResponseStatus.NOTIFICATION_SUCCESS && <NotificationDownloadFile notification={notification}/>}
    </>;
};

export default LogNotification;
